import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _DOWNLOAD_FORMATS_TO_, _DOWNLOAD_FORMATS_TO_2;
// Images
import excelSvg from '../../assets/images/excel.svg';
import pdfSvg from '../../assets/images/pdf.svg';
import xmlSvg from '../../assets/images/xml.svg';
import txtSvg from '../../assets/images/txt.svg';
var TOP_RIGHT = 'tr';
var BOTTOM_RIGHT = 'br';
var PDF_FORMAT = 'PDF';
var TXT_FORMAT = 'TXT';
var EXCEL_FORMAT = 'EXCEL';
var XML_FORMAT = 'XML';
export var DOWNLOAD_FORMATS = {
  PDF_FORMAT: PDF_FORMAT,
  EXCEL_FORMAT: EXCEL_FORMAT,
  XML_FORMAT: XML_FORMAT,
  TXT_FORMAT: TXT_FORMAT
};
export var DOWNLOAD_FORMATS_TO_ICONS = (_DOWNLOAD_FORMATS_TO_ = {}, _defineProperty(_DOWNLOAD_FORMATS_TO_, PDF_FORMAT, pdfSvg), _defineProperty(_DOWNLOAD_FORMATS_TO_, EXCEL_FORMAT, excelSvg), _defineProperty(_DOWNLOAD_FORMATS_TO_, XML_FORMAT, xmlSvg), _defineProperty(_DOWNLOAD_FORMATS_TO_, TXT_FORMAT, txtSvg), _DOWNLOAD_FORMATS_TO_);
export var DOWNLOAD_FORMATS_TO_LABELS = (_DOWNLOAD_FORMATS_TO_2 = {}, _defineProperty(_DOWNLOAD_FORMATS_TO_2, PDF_FORMAT, __('PDF')), _defineProperty(_DOWNLOAD_FORMATS_TO_2, EXCEL_FORMAT, __('Excel')), _defineProperty(_DOWNLOAD_FORMATS_TO_2, XML_FORMAT, __('XML')), _defineProperty(_DOWNLOAD_FORMATS_TO_2, TXT_FORMAT, __('Text')), _DOWNLOAD_FORMATS_TO_2);
export var ALIGN_CONFIG = {
  points: [TOP_RIGHT, BOTTOM_RIGHT],
  offset: [0, 10]
};